<template>
  <div>
      <Info />
      <CheckTable :checkList=finalCheck @changedCheckbox=changedCheckbox></CheckTable>
      <ButtonBar @back="back" @next="next" nextBtnTitle="メンテナンス情報を送信"></ButtonBar>
  </div>
</template>

<script>
  import CheckTable from '@/components/parts/CheckTable';

  export default {
    name: 'FinalCheck',
    components: {
      CheckTable,
    },
    created() {
      this.$parent.title = '';
      this.$parent.imageName = 'finalCheck';
      this.$parent.hasMaintenancne = true;
      this.$parent.showMaintenanceInformation = true;
    },
    data() {
      return {
        finalCheck: this.$store.getters.finalCheck,
        backPageName: this.$store.getters.routes.finalCheck.back,
        nextPageName: this.$store.getters.routes.finalCheck.next,
      };
    },
    methods: {
      back() {
        this.$router.push({ name: this.backPageName });
      },
      next() {
        const result = Object.values(this.finalCheck.answers).some(value => !value);
        if (result) {
          alert('未選択のチェック項目があります。');
        } else {
          if (window.confirm('メンテナンス情報を送信しますか？')) {
            this.$store.dispatch('saveMaintenanceData')
              .then(() => {
                this.$parent.hasMaintenancne = false;
                this.$router.push({ name: this.nextPageName });
              })
              .catch((e) => {
                if (e.status == 401) {
                  alert(e.data.error.message);
                  this.$router.push({ name: 'SignIn', replace: true })
                  return;
                }
                alert(e.data.error.message);
              });
          }
        }
        return true;
      },
      changedCheckbox(key, answer) {
        const type = 'finalCheck';
        this.$store.dispatch('setCheckAnswer', { type, key, answer });
      },
    },
  };
</script>

<style lang="scss" scoped>
  dl {
    dt, dd {
      padding: 0.5rem 3rem;

      .md-checkbox.md-theme-default.md-checked .md-ripple {
        color: #52ff52;
        color: var(--md-theme-default-accent, #52ff52);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FinalCheck.vue?5ac61c9a